import { TCurrentLocation } from '../../common/state';

export enum ECurrentLocations {
  moscowAndMO = 'Москва и область',
  spbAndLO = 'Санкт-Петербург и область',
}

/**
 * Возвращает текст выбранного города или регионов Москва + МО, СПБ + МО.
 * @param currentLocation
 */
export function getCity(currentLocation: TCurrentLocation) {
  switch (currentLocation) {
    case 'moscow_mo':
      return ECurrentLocations.moscowAndMO;
    case 'spb_lo':
      return ECurrentLocations.spbAndLO;
    default:
      return currentLocation.displayName;
  }
}
